import React from "react";
import Logo from "@/components/Logo";
import { Linkedin, Facebook, Instagram, ArrowUp } from "lucide-react";

export const Footer = () => {
  const year = new Date().getFullYear();
  const scrollTop = () =>
    window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer
      data-testid="main-footer"
      className="relative border-t border-white/10 bg-[#181C24] pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 pb-14 border-b border-white/10">
          <div className="lg:col-span-5">
            <Logo />
            <p className="mt-6 text-sm text-white/55 leading-relaxed max-w-md">
              Infraestructura tecnológica y de telecomunicaciones para el
              sector industrial de Saltillo, Ramos Arizpe y el noreste de
              México.
            </p>
            <div className="mt-8 flex items-center gap-3">
              {[
                { icon: Linkedin, href: "#", label: "linkedin" },
                { icon: Facebook, href: "#", label: "facebook" },
                { icon: Instagram, href: "#", label: "instagram" },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  data-testid={`footer-social-${s.label}`}
                  aria-label={s.label}
                  className="w-10 h-10 inline-flex items-center justify-center border border-white/15 hover:border-[#F8BC33] hover:text-[#F8BC33] transition-colors"
                >
                  <s.icon className="w-4 h-4" strokeWidth={1.5} />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="font-mono-tech text-[10px] uppercase tracking-widest text-white/40 mb-5">
              Servicios
            </div>
            <ul className="space-y-3 text-sm text-white/75">
              {[
                "Videovigilancia",
                "Control de acceso",
                "Redes empresariales",
                "Fibra óptica",
                "HVAC industrial",
                "Construcción",
              ].map((s) => (
                <li key={s}>
                  <a
                    href="#servicios"
                    className="hover:text-[#F8BC33] transition-colors"
                  >
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="font-mono-tech text-[10px] uppercase tracking-widest text-white/40 mb-5">
              Empresa
            </div>
            <ul className="space-y-3 text-sm text-white/75">
              <li><a href="#nosotros" className="hover:text-[#F8BC33] transition-colors">Nosotros</a></li>
              <li><a href="#porque" className="hover:text-[#F8BC33] transition-colors">Diferenciadores</a></li>
              <li><a href="#sectores" className="hover:text-[#F8BC33] transition-colors">Sectores</a></li>
              <li><a href="#contacto" className="hover:text-[#F8BC33] transition-colors">Contacto</a></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="font-mono-tech text-[10px] uppercase tracking-widest text-white/40 mb-5">
              Contacto
            </div>
            <ul className="space-y-3 text-sm text-white/75">
              <li>Saltillo, Coahuila</li>
              <li>+52 844 000 0000</li>
              <li>contacto@infratelco.mx</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-white/45 font-mono-tech tracking-wider">
            © {year} INFRATELCO S.A. de C.V. · Todos los derechos reservados ·
            Aviso de privacidad
          </p>
          <button
            type="button"
            onClick={scrollTop}
            data-testid="footer-scroll-top"
            className="inline-flex items-center gap-2 text-xs uppercase font-mono-tech tracking-widest text-white/55 hover:text-[#F8BC33] transition-colors"
          >
            Subir <ArrowUp className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
